import { toProgramLandingPageUrl } from '@client/helpers/routes';

const LANDING_URL = import.meta.env.VITE_LANDING_PAGE_URL;

export function programUrl(
  influencer: { customURL: string },
  program: { id: number; name: string },
) {
  return getSalesPageUrl({
    customURL: influencer.customURL,
    id: program.id,
    name: program.name,
  });
}

export const getSalesPageUrl = ({
  customURL,
  ...p
}: {
  customURL: string;
  id: number;
  name?: string | null | undefined;
}) => {
  if (!customURL || !p.name) return '';

  const programUrl = toProgramLandingPageUrl({
    id: p.id,
    name: p.name,
    influencer: { customURL },
  });
  return programUrl;
};

function sluggify(str: string) {
  return str
    .replace(/ - /g, '-')
    .replace(/#/g, '')
    .replace(/[^ -~]+/g, '')
    .trim()
    .replace(/[ ]+/g, '-')
    .replace(/\//g, '-')
    .replace(/\?/g, '');
}
